webpackJsonp([213720915766396],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(41);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGithub = function FaGithub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6q0 5.6-3.3 10.1t-8.4 6.2q-0.6 0.1-0.9-0.2t-0.3-0.7q0 0 0-1.7t0-3q0-2.1-1.2-3.1 1.3-0.2 2.3-0.4t2.1-0.9 1.8-1.5 1.2-2.3 0.5-3.4q0-2.7-1.8-4.6 0.8-2-0.2-4.5-0.6-0.2-1.8 0.2t-2 1l-0.9 0.5q-2-0.6-4.3-0.6t-4.2 0.6q-0.4-0.2-1-0.6t-1.9-0.8-1.9-0.3q-1 2.5-0.1 4.5-1.8 1.9-1.8 4.6 0 1.9 0.5 3.4t1.1 2.3 1.8 1.5 2.1 0.9 2.3 0.4q-0.9 0.8-1.1 2.3-0.4 0.2-1 0.3t-1.3 0.1-1.4-0.5-1.3-1.4q-0.4-0.7-1-1.1t-1.1-0.6l-0.5 0q-0.5 0-0.6 0.1t-0.1 0.2 0.2 0.3 0.2 0.3l0.2 0.1q0.5 0.2 1 0.9t0.7 1.1l0.2 0.5q0.3 0.9 1 1.4t1.5 0.7 1.5 0.1 1.3-0.1l0.5 0q0 0.8 0 1.9t0 1.2q0 0.5-0.3 0.7t-0.9 0.2q-5.2-1.7-8.4-6.2t-3.3-10.1q0-4.7 2.3-8.6t6.2-6.2 8.6-2.3z m-10.6 24.6q0.1-0.2-0.2-0.3-0.2-0.1-0.2 0.1-0.1 0.1 0.1 0.2 0.2 0.2 0.3 0z m0.7 0.7q0.1-0.1-0.1-0.3-0.2-0.2-0.3-0.1-0.2 0.1 0 0.4 0.3 0.2 0.4 0z m0.7 1q0.2-0.1 0-0.4-0.2-0.3-0.4-0.1-0.2 0.1 0 0.4t0.4 0.1z m0.9 1q0.2-0.2-0.1-0.4-0.3-0.3-0.4-0.1-0.2 0.2 0 0.4 0.3 0.3 0.5 0.1z m1.3 0.5q0-0.2-0.3-0.3-0.4-0.1-0.4 0.1t0.2 0.4q0.4 0.1 0.5-0.2z m1.4 0.1q0-0.2-0.4-0.2-0.4 0-0.4 0.2 0 0.3 0.4 0.3 0.4 0 0.4-0.3z m1.3-0.2q-0.1-0.2-0.4-0.2-0.4 0.1-0.3 0.4t0.4 0.1 0.3-0.3z' })
	        )
	    );
	};
	
	exports.default = FaGithub;
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(41);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoAlert = function GoAlert(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.3 31.3l-17.1-30c-0.5-0.8-1.3-1.3-2.2-1.3s-1.7 0.5-2.2 1.3l-17.1 30c-0.4 0.7-0.4 1.7 0 2.5s1.3 1.2 2.2 1.2h34.2c0.9 0 1.7-0.5 2.2-1.2s0.4-1.8 0-2.5z m-16.8-1.3h-5v-5h5v5z m0-7.5h-5v-10h5v10z' })
	        )
	    );
	};
	
	exports.default = GoAlert;
	module.exports = exports['default'];

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/astar-Optimized.458551d2.png";

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/colors-Optimized.1feae651.png";

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dt-Optimized.aaf75934.png";

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/emunah-Optimized.32b5f406.png";

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fancofan-Optimized.4093a361.png";

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gili-Optimized.35a3d304.png";

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lordofwar-Optimized.250be7e0.png";

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/newoldroad-Optimized.55c74f8d.png";

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dtOptimized = __webpack_require__(605);
	
	var _dtOptimized2 = _interopRequireDefault(_dtOptimized);
	
	var _emunahOptimized = __webpack_require__(606);
	
	var _emunahOptimized2 = _interopRequireDefault(_emunahOptimized);
	
	var _giliOptimized = __webpack_require__(608);
	
	var _giliOptimized2 = _interopRequireDefault(_giliOptimized);
	
	var _colorsOptimized = __webpack_require__(604);
	
	var _colorsOptimized2 = _interopRequireDefault(_colorsOptimized);
	
	var _lordofwarOptimized = __webpack_require__(609);
	
	var _lordofwarOptimized2 = _interopRequireDefault(_lordofwarOptimized);
	
	var _astarOptimized = __webpack_require__(603);
	
	var _astarOptimized2 = _interopRequireDefault(_astarOptimized);
	
	var _fancofanOptimized = __webpack_require__(607);
	
	var _fancofanOptimized2 = _interopRequireDefault(_fancofanOptimized);
	
	var _newoldroadOptimized = __webpack_require__(610);
	
	var _newoldroadOptimized2 = _interopRequireDefault(_newoldroadOptimized);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clientProjects = [{
	  name: 'Emunah',
	  description: 'Community site for Rav Dror of Emunah. Hooks into youtube, twitter and soundcloud apis to bring all content to one place.',
	  stack: 'angular, youtube, soundcloud apis',
	  url: 'https://emunah.com/home',
	  github: 'https://github.com/mbreslow56/Emunah',
	  img: _emunahOptimized2.default
	}, {
	  name: 'Dank Tickets',
	  description: 'Ticketing event site for California marijuana conventions. The first project where I incorporate lots of CSS Grid. I also hooked up \'Nodemailer\' as part of user validation flow.',
	  stack: 'AngularJS, mongodb, node, express',
	  url: 'https://danktickets.herokuapp.com/home',
	  github: 'https://github.com/mbreslow56/danktickets2.0',
	  img: _dtOptimized2.default
	}, {
	  name: 'Gili\'s Towing',
	  description: 'Company page for local Israeli towing service. First multilingual app. I conditonally render rtl or ltr content based on browser language.',
	  stack: 'React / GatsbyJS, Glympse Location tracker',
	  url: 'http://giligrartelaviv.co.il',
	  github: 'https://github.com/mbreslow56/Gili-Towing',
	  img: _giliOptimized2.default
	}, {
	  name: 'New Old Road',
	  description: 'Company landing for Web Dev Studio. Responsive design integrating the ParticlesJS library.',
	  stack: 'AngularJS, ParticlesJS',
	  url: 'http://www.newoldroad.com',
	  github: 'https://github.com/mbreslow56/newoldroad',
	  img: _newoldroadOptimized2.default
	}, {
	  name: 'Hebrew Vocabulary Game',
	  description: 'Small Matching game done for Language Fountain. I wrote animations for slider on top of ng-animate and synced up audio callbacks from a single audio file using start/stop times.',
	  stack: 'angularjs, angular material',
	  url: 'https://katzy687.github.io/hebrew-colors-webpack-ts/#!/',
	  github: 'https://github.com/katzy687/hebrew-colors-webpack-ts',
	  img: _colorsOptimized2.default
	}];
	
	var personalProjects = [{
	  name: 'Lord Of War',
	  description: 'Small Angular4 project I made for an interview assignment and had a lot of fun with. My first interaction with \'observables\', needed to broadcast changes live across parallel components.',
	  stack: 'Angular 4',
	  url: 'https://katzy687.github.io/lord-of-war',
	  github: 'https://github.com/katzy687/lord-of-war',
	  img: _lordofwarOptimized2.default
	}, {
	  name: 'A-Star-Angular',
	  description: 'Small project incorporating the A* pathfinding algorithm into an angularjs UI. The task was an interview assignment, given without proposing an algorithm. I elected to use the A* algorithm over breadth-first-search (BFS) because there is a heuristic of direction that makes it more efficient.',
	  stack: 'AngularJS, Angular Material, A-Star Pathfinding module',
	  url: 'https://a-star-angular.herokuapp.com/#!/main',
	  github: 'https://github.com/katzy687/A-Star-Angular',
	  img: _astarOptimized2.default
	}, {
	  name: 'Fanco-Fan',
	  description: 'My final project from coding bootcamp, assigned by IBM. I used D3 to visualize seasonal weather data and correlate it with fan sales for a fictional company. Turns out people don\'t buy fans in the winter :).',
	  stack: 'D3, AngularJS, Twilio, WeatherAPI',
	  url: 'https://fancofan.herokuapp.com/#/home/totalSales',
	  github: 'https://github.com/benjkn/Hackathon_task-FanCo',
	  img: _fancofanOptimized2.default
	}];
	
	var projects = { clientProjects: clientProjects, personalProjects: personalProjects };
	
	exports.default = projects;
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__(559);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _projects = __webpack_require__(240);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _projectsModule = __webpack_require__(334);
	
	var _projectsModule2 = _interopRequireDefault(_projectsModule);
	
	var _github = __webpack_require__(556);
	
	var _github2 = _interopRequireDefault(_github);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Project);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      slideOpen: false,
	      imageLoading: true
	    }, _this.toggleState = function () {
	      console.log('toggling slide state');
	      _this.setState({ slideOpen: !_this.state.slideOpen });
	    }, _this.handleClick = function (e) {
	      if (window.innerWidth > 768) {
	        console.log('big screen, cancel click');
	        return;
	      }
	      console.log('handle click fired');
	      _this.toggleState();
	      e.stopPropagation();
	    }, _this.handleMouse = function (e) {
	      if (window.innerWidth <= 768) {
	        console.log('small screen, cancel hover');
	        return;
	      }
	      console.log('handle mouse fired');
	      _this.toggleState();
	      e.stopPropagation();
	    }, _this.handleImageLoaded = function () {
	      console.log('image loaded fired');
	      _this.setState({ imageLoading: false });
	    }, _this.handleImageError = function () {
	      _this.setState({ imageLoading: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Project.prototype.render = function render() {
	    var isOpen = this.state.slideOpen ? _projectsModule2.default.open : '';
	    var loaderStatus = this.state.imageLoading ? _react2.default.createElement(
	      'div',
	      { className: 'loader' },
	      'Loading...'
	    ) : null;
	    var descStyle = this.state.imageLoading ? { display: 'none' } : { display: 'block' };
	    return _react2.default.createElement(
	      'li',
	      { className: _projectsModule2.default.CardContainer, onClick: this.handleClick },
	      _react2.default.createElement(
	        'div',
	        { className: _projectsModule2.default.imageContainer, onMouseEnter: this.handleMouse, onMouseLeave: this.handleMouse },
	        loaderStatus,
	        _react2.default.createElement(
	          'p',
	          { className: _projectsModule2.default.description, style: descStyle },
	          this.props.project.description
	        ),
	        _react2.default.createElement('img', { src: this.props.project.img, alt: this.props.project.name,
	          className: [_projectsModule2.default.slider, isOpen].join(' '),
	          onLoad: this.handleImageLoaded,
	          onError: this.handleImageError
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _projectsModule2.default.metadata },
	        _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold' } },
	          this.props.project.name
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { style: { fontStyle: 'italic' } },
	            'Stack'
	          ),
	          ': ',
	          this.props.project.stack
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            }, className: _projectsModule2.default.projectLinks },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.project.url, target: '_blank' },
	            'URL'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: this.props.project.github, style: { fontSize: '2rem' }, target: '_blank' },
	            _react2.default.createElement(_github2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	var ProjectsContainer = function ProjectsContainer(props) {
	
	  var projects = props.projectList.map(function (project) {
	    // const projectImg = props.gatsbyImages[project.imgKey];
	    // console.log(projectImg);
	    return _react2.default.createElement(Project, { project: project, key: project.name });
	  });
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _projectsModule2.default.projectContainer },
	    projects
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: [_projectsModule2.default.PageContainer, 'page-styles'].join(' ') },
	    _react2.default.createElement(
	      'p',
	      { className: 'mobile-only', style: { textAlign: 'center', fontSize: '1rem' } },
	      '( tap on card to read more )'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'desktop-only', style: { textAlign: 'center', fontSize: '1rem' } },
	      '( hover on card to read more )'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Client Projects'
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: _projectsModule2.default.ClientProjects },
	      _react2.default.createElement(ProjectsContainer, { projectList: _projects2.default.clientProjects })
	    ),
	    _react2.default.createElement(
	      'h3',
	      { style: { marginTop: '2rem' } },
	      'Personal Projects'
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: _projectsModule2.default.PersonalProjects },
	      _react2.default.createElement(ProjectsContainer, { projectList: _projects2.default.personalProjects })
	    )
	  );
	};
	
	// export const query = graphql`
	//   query BlurUpQuery {
	//     emunahPic: imageSharp(id: { regex: "/emunah.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     dtPic: imageSharp(id: { regex: "/dt.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     giliPic: imageSharp(id: { regex: "/gilitowing.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     colorsPic: imageSharp(id: { regex: "/colors.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     lordOfWarPic: imageSharp(id: { regex: "/lordofwar.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     aStarPic: imageSharp(id: { regex: "/astar.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//     fancoPic: imageSharp(id: { regex: "/fancofan.png/" }) {
	//       resolutions(width:400, height: 222) {
	//         ...GatsbyImageSharpResolutions
	//       }
	//     }
	//   }
	// `
	

	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectLinks":"src-pages----projects-module---projectLinks---1sU5l","PageContainer":"src-pages----projects-module---PageContainer---14msp","GatsbyImgOuterWrapper":"src-pages----projects-module---GatsbyImgOuterWrapper---3ElKp","ClientProjects":"src-pages----projects-module---ClientProjects---3TP9I","PersonalProjects":"src-pages----projects-module---PersonalProjects---14G_1","CardContainer":"src-pages----projects-module---CardContainer---46nCs","description":"src-pages----projects-module---description---2eWpz","metadata":"src-pages----projects-module---metadata---391Rf","imageContainer":"src-pages----projects-module---imageContainer---2zWHW","slider":"src-pages----projects-module---slider---2fm9e","open":"src-pages----projects-module---open---3ZdEZ","projectContainer":"src-pages----projects-module---projectContainer---2BkPS"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-4fa9e78deb4c2f704a6f.js